(function () {
  var STORAGE_KEY = 'onera_launch_dismissed';
  var ACCESS_STORAGE_KEY = 'onera_launch_access_code';
  var SIGNED_UP_EMAILS_STORAGE_KEY = 'onera_launch_signed_up_emails';
  var ACCESS_INACTIVITY_TIMEOUT = 30 * 60 * 1000;
  var ACCESS_ACTIVITY_EVENTS = [
    'click',
    'keydown',
    'mousemove',
    'scroll',
    'touchstart'
  ];
  var accessPassActive = false;
  var accessPassCode = '';
  var accessRefreshTimer = null;
  var accessLastRefresh = 0;
  var accessTrackingStarted = false;

  var buildNote = function (email, phone) {
    var parts = ['ONERA early access'];
    if (email) {
      parts.push('Email: ' + email);
    }
    if (phone) {
      parts.push('Phone: ' + phone);
    }
    parts.push('Signed up: ' + new Date().toISOString());
    return parts.join(' | ');
  };

  var getDuplicateMessage = function (splash) {
    return (
      splash.getAttribute('data-duplicate-message') ||
      "You're already on the list."
    );
  };

  var showSplash = function (splash) {
    document.body.classList.remove('launch-mode-pending', 'launch-mode-dismissed');
    document.body.classList.add('launch-mode-active');
    splash.hidden = false;
  };

  var getAccessCode = function (splash) {
    return (splash.getAttribute('data-access-code') || '').trim();
  };

  var hasShopifySignupSuccess = function () {
    return window.location.search.indexOf('customer_posted=true') !== -1;
  };

  var cleanSignupUrl = function () {
    if (!window.history || !window.history.replaceState) {
      return;
    }

    var url = new URL(window.location.href);
    url.searchParams.delete('customer_posted');
    if (url.hash === '#onera-launch-form') {
      url.hash = '';
    }
    window.history.replaceState({}, document.title, url.toString());
  };

  var hideSplash = function (splash) {
    splash.hidden = true;
    document.body.classList.remove('launch-mode-pending', 'launch-mode-active');
    document.body.classList.add('launch-mode-dismissed');
    document.dispatchEvent(new Event('onera:launch-dismissed'));
  };

  var clearLegacyDismissedState = function () {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* sessionStorage unavailable */
    }
  };

  var readAccessPass = function () {
    try {
      var raw = localStorage.getItem(ACCESS_STORAGE_KEY);
      if (!raw) {
        return null;
      }

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') {
        localStorage.removeItem(ACCESS_STORAGE_KEY);
        return null;
      }

      return parsed;
    } catch (error) {
      try {
        localStorage.removeItem(ACCESS_STORAGE_KEY);
      } catch (removeError) {
        /* localStorage unavailable */
      }
      return null;
    }
  };

  var writeAccessPass = function (accessCode) {
    try {
      localStorage.setItem(
        ACCESS_STORAGE_KEY,
        JSON.stringify({
          code: accessCode,
          lastActive: Date.now()
        })
      );
    } catch (error) {
      /* localStorage unavailable */
    }
  };

  var clearAccessPass = function () {
    try {
      localStorage.removeItem(ACCESS_STORAGE_KEY);
    } catch (error) {
      /* localStorage unavailable */
    }
  };

  var normalizeEmail = function (email) {
    return (email || '').trim().toLowerCase();
  };

  var readSignedUpEmails = function () {
    try {
      var raw = localStorage.getItem(SIGNED_UP_EMAILS_STORAGE_KEY);
      var emails = raw ? JSON.parse(raw) : [];
      return Array.isArray(emails) ? emails : [];
    } catch (error) {
      return [];
    }
  };

  var hasSignedUpEmail = function (email) {
    var normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail) {
      return false;
    }

    return readSignedUpEmails().indexOf(normalizedEmail) !== -1;
  };

  var rememberSignedUpEmail = function (email) {
    var normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail) {
      return;
    }

    try {
      var emails = readSignedUpEmails();
      if (emails.indexOf(normalizedEmail) === -1) {
        emails.push(normalizedEmail);
      }
      localStorage.setItem(
        SIGNED_UP_EMAILS_STORAGE_KEY,
        JSON.stringify(emails.slice(-50))
      );
    } catch (error) {
      /* localStorage unavailable */
    }
  };

  var hasValidAccessPass = function (accessCode) {
    var pass = readAccessPass();
    var now = Date.now();

    if (!accessCode || !pass || pass.code !== accessCode || !pass.lastActive) {
      clearAccessPass();
      return false;
    }

    if (now - Number(pass.lastActive) > ACCESS_INACTIVITY_TIMEOUT) {
      clearAccessPass();
      return false;
    }

    return true;
  };

  var expireAccessPass = function (splash) {
    accessPassActive = false;
    accessPassCode = '';
    clearAccessPass();
    if (accessRefreshTimer) {
      clearTimeout(accessRefreshTimer);
      accessRefreshTimer = null;
    }
    showSplash(splash);
  };

  var scheduleAccessExpiry = function (splash) {
    if (accessRefreshTimer) {
      clearTimeout(accessRefreshTimer);
    }
    accessRefreshTimer = setTimeout(function () {
      expireAccessPass(splash);
    }, ACCESS_INACTIVITY_TIMEOUT);
  };

  var refreshAccessPass = function (splash, force) {
    var now = Date.now();
    if (!accessPassActive || !accessPassCode) {
      return;
    }

    if (!force && now - accessLastRefresh < 10000) {
      return;
    }

    if (!hasValidAccessPass(accessPassCode)) {
      expireAccessPass(splash);
      return;
    }

    accessLastRefresh = now;
    writeAccessPass(accessPassCode);
    scheduleAccessExpiry(splash);
  };

  var startAccessTracking = function (splash) {
    if (accessTrackingStarted) {
      return;
    }

    ACCESS_ACTIVITY_EVENTS.forEach(function (eventName) {
      document.addEventListener(
        eventName,
        function () {
          refreshAccessPass(splash, false);
        },
        { passive: true }
      );
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        refreshAccessPass(splash, true);
      }
    });

    accessTrackingStarted = true;
  };

  var activateAccessPass = function (splash, accessCode) {
    accessPassActive = true;
    accessPassCode = accessCode;
    accessLastRefresh = 0;
    writeAccessPass(accessCode);
    startAccessTracking(splash);
    scheduleAccessExpiry(splash);
    hideSplash(splash);
  };

  var showSuccess = function (splash, message) {
    var formWrap = splash.querySelector('[data-launch-form-wrap]');
    var success = splash.querySelector('[data-launch-success]');
    var runtimeSuccess = splash.querySelector('[data-launch-runtime-success]');
    var staticSuccess = splash.querySelector('[data-launch-static-success]');
    var errorEl = splash.querySelector('[data-launch-error]');
    if (formWrap) {
      formWrap.hidden = true;
    }
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    if (success) {
      success.hidden = false;
    }
    if (message && runtimeSuccess) {
      runtimeSuccess.textContent = message;
      runtimeSuccess.hidden = false;
      if (staticSuccess) {
        staticSuccess.hidden = true;
      }
    } else {
      if (runtimeSuccess) {
        runtimeSuccess.textContent = '';
        runtimeSuccess.hidden = true;
      }
      if (staticSuccess) {
        staticSuccess.hidden = false;
      }
    }
  };

  var submitContactFallback = function (email, phone, contactForm) {
    var emailField = contactForm.querySelector('#LaunchContactEmail');
    var bodyField = contactForm.querySelector('#LaunchContactBody');
    if (!emailField || !bodyField) {
      return Promise.reject(new Error('Fallback unavailable'));
    }

    emailField.value = email;
    bodyField.value = buildNote(email, phone);

    var formData = new FormData(contactForm);
    var body = new URLSearchParams(formData);
    var url = contactActionUrl(contactForm);
    return fetch(url, {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json, text/javascript, */*;q=0.01',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
  };

  var getServerErrors = function (html) {
    if (!html || !window.DOMParser) {
      return '';
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var serverErrors = doc.querySelector('[data-launch-server-errors]');
    return serverErrors ? serverErrors.textContent.trim() : '';
  };

  var isDuplicateSignup = function (text) {
    var normalized = (text || '').toLowerCase();
    return (
      normalized.indexOf('already subscribed') !== -1 ||
      normalized.indexOf('already signed up') !== -1 ||
      normalized.indexOf('already on the list') !== -1 ||
      normalized.indexOf('already associated') !== -1 ||
      normalized.indexOf('already been taken') !== -1 ||
      normalized.indexOf('email already exists') !== -1 ||
      normalized.indexOf('customer already exists') !== -1
    );
  };

  var hasCustomerPostedSuccess = function (response, html) {
    if (response && response.url && response.url.indexOf('customer_posted=true') !== -1) {
      return true;
    }
    if (!html || !window.DOMParser) {
      return html ? html.indexOf('data-launch-posted-success') !== -1 : false;
    }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Boolean(doc.querySelector('[data-launch-posted-success]'));
  };

  var contactActionUrl = function (customerForm) {
    var action = (customerForm && customerForm.getAttribute('action')) || '/contact';
    return action.split('#')[0] || '/contact';
  };

  var withCaptcha = function (form, done) {
    if (
      window.Shopify &&
      window.Shopify.captcha &&
      typeof window.Shopify.captcha.protect === 'function'
    ) {
      try {
        window.Shopify.captcha.protect(form, function () {
          done();
        });
        return;
      } catch (error) {
        /* Fall through and attempt submit without protect(). */
      }
    }
    done();
  };

  /* Shopify /contact expects urlencoded POST; multipart FormData often 400s.
     Success = customer_posted, posted-success marker, or 2xx JSON without errors. */
  var submitCustomerForm = function (customerForm) {
    var formData = new FormData(customerForm);
    var body = new URLSearchParams(formData);
    var url = contactActionUrl(customerForm);

    return fetch(url, {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json, text/javascript, */*;q=0.01',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      var contentType = (response.headers.get('Content-Type') || '').toLowerCase();

      if (contentType.indexOf('application/json') !== -1) {
        return response
          .json()
          .then(function (data) {
            var errorText = '';
            if (data) {
              if (typeof data.description === 'string') {
                errorText = data.description;
              } else if (typeof data.message === 'string') {
                errorText = data.message;
              } else if (typeof data.errors === 'string') {
                errorText = data.errors;
              } else if (data.email) {
                errorText = Array.isArray(data.email)
                  ? data.email.join(' ')
                  : String(data.email);
              } else if (data.errors) {
                try {
                  errorText = JSON.stringify(data.errors);
                } catch (error) {
                  errorText = 'Signup failed';
                }
              }
            }

            if (isDuplicateSignup(errorText)) {
              return { status: 'duplicate' };
            }
            if (errorText && !response.ok) {
              return { status: 'error', message: errorText };
            }
            if (response.ok || hasCustomerPostedSuccess(response, '')) {
              return { status: 'success' };
            }
            return { status: 'error', message: errorText || '' };
          })
          .catch(function () {
            if (response.ok || hasCustomerPostedSuccess(response, '')) {
              return { status: 'success' };
            }
            return { status: 'error' };
          });
      }

      return response.text().then(function (html) {
        var serverErrors = getServerErrors(html);

        if (isDuplicateSignup(serverErrors) || isDuplicateSignup(html)) {
          return { status: 'duplicate' };
        }

        if (serverErrors) {
          return { status: 'error', message: serverErrors };
        }

        if (hasCustomerPostedSuccess(response, html)) {
          return { status: 'success' };
        }

        if (response.ok) {
          return { status: 'success' };
        }

        return { status: 'error' };
      });
    });
  };

  var initLaunchSplash = function () {
    var splash = document.querySelector('[data-onera-launch]');
    if (!splash) {
      return;
    }

    clearLegacyDismissedState();

    var accessCode = getAccessCode(splash);
    if (hasValidAccessPass(accessCode)) {
      activateAccessPass(splash, accessCode);
      return;
    }

    showSplash(splash);

    if (hasShopifySignupSuccess()) {
      showSuccess(splash);
      cleanSignupUrl();
      return;
    }

    var customerForm = splash.querySelector('#onera-launch-form');
    var contactForm = splash.querySelector('#onera-launch-contact-fallback');
    var errorEl = splash.querySelector('[data-launch-error]');
    var submitButton = splash.querySelector('[data-launch-submit]');
    var dismissButton = splash.querySelector('[data-launch-dismiss]');
    var accessForm = splash.querySelector('[data-launch-access-form]');
    var accessInput = splash.querySelector('[data-launch-access-input]');
    var accessError = splash.querySelector('[data-launch-access-error]');

    if (customerForm) {
      customerForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!submitButton) {
          return;
        }

        var emailInput = customerForm.querySelector('#LaunchEmail');
        var phoneInput = customerForm.querySelector('#LaunchPhone');
        var email = emailInput ? emailInput.value.trim() : '';
        var phone = phoneInput ? phoneInput.value.trim() : '';

        if (!email) {
          return;
        }

        if (hasSignedUpEmail(email)) {
          showSuccess(splash, getDuplicateMessage(splash));
          return;
        }

        submitButton.disabled = true;
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        withCaptcha(customerForm, function () {
          submitCustomerForm(customerForm)
            .then(function (result) {
              if (result.status === 'success') {
                rememberSignedUpEmail(email);
                showSuccess(splash);
                if (phone && contactForm) {
                  submitContactFallback(email, phone, contactForm).catch(
                    function () {
                      /* Phone note failed, but the Shopify customer signup succeeded. */
                    }
                  );
                }
                return;
              }

              if (result.status === 'duplicate') {
                rememberSignedUpEmail(email);
                showSuccess(splash, getDuplicateMessage(splash));
                return;
              }

              throw new Error(
                (result && result.message) || 'Signup failed'
              );
            })
            .catch(function (error) {
              var message =
                (error && error.message && error.message !== 'Signup failed'
                  ? error.message
                  : null) ||
                splash.getAttribute('data-error-message') ||
                'Something went wrong. Please try again shortly.';
              if (errorEl) {
                errorEl.textContent = message;
                errorEl.hidden = false;
              }
              submitButton.disabled = false;
            });
        });
      });
    }

    if (dismissButton) {
      dismissButton.addEventListener('click', function () {
        hideSplash(splash);
      });
    }

    if (accessForm && accessInput) {
      accessForm.addEventListener('submit', function (event) {
        event.preventDefault();

        var enteredCode = accessInput.value.trim();
        if (accessCode && enteredCode === accessCode) {
          activateAccessPass(splash, accessCode);
          return;
        }

        var message =
          splash.getAttribute('data-access-error-message') ||
          'Incorrect access code.';
        if (accessError) {
          accessError.textContent = message;
          accessError.hidden = false;
        }
        accessInput.select();
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLaunchSplash);
  } else {
    initLaunchSplash();
  }
})();
